import React, { useEffect } from 'react';
import { Tabs } from '@hills-design-system/components';
import { useTranslation } from '../../hooks/useTranslation';
import { TranslationKeyEnum } from '../../types/constants';
import ContactUs from './components/ContactUs';
import PortalTutorials from './components/PortalTutorials';
import Faqs from './components/Faqs';
import { useSearchParams } from 'react-router-dom';

const DEFAULT_TAB = 'contact-us';

const Help: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const tabParam = searchParams.get('tab');
  const [activeTab, setActiveTab] = React.useState(tabParam ?? DEFAULT_TAB);
  const { t } = useTranslation();

  useEffect(() => {
    // If the tab param changes externally, update the state
    if (tabParam && tabParam !== activeTab) {
      setActiveTab(tabParam);
    }
    // If no tab param, set it to default
    if (!tabParam) {
      setSearchParams({ tab: DEFAULT_TAB }, { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tabParam]);

  const tabItems = [
    { id: 'contact-us', label: t(TranslationKeyEnum.ContactUs) },
    { id: 'program-tutorials', label: t(TranslationKeyEnum.Tutorials) },
    { id: 'faqs', label: t(TranslationKeyEnum.FAQs) },
  ];

  const handleTabChange = (tabId: string) => {
    setActiveTab(tabId);
    setSearchParams({ tab: tabId });
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case 'contact-us':
        return <ContactUs />;
      case 'program-tutorials':
        return <PortalTutorials />;
      case 'faqs':
        return <Faqs />;
      default:
        return <ContactUs />;
    }
  };

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <main className="flex-grow">
        {/* Page Header */}
        <div className=" pb-12">
          <h1 className="text-[64px] font-bold tracking-[-3%] text-[#192026] leading-[1.125em]">
            {t(TranslationKeyEnum.Help)}
          </h1>
        </div>

        {/* Tabs */}
        <Tabs items={tabItems} activeTab={activeTab} onChange={handleTabChange} />

        {/* Content */}
        <div className=" py-8 flex flex-col items-center">{renderTabContent()}</div>
      </main>
    </div>
  );
};

export default Help;
